import axiosApi, { setHeader } from "api/root.api";

export const deleteProject = async (projectID, token) => {
  const urlEnd = `/editor/project/v1/${projectID}`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.delete(urlEnd);
  const result = response.data;
  return result;
};
